<template>
  <footer class="mt-auto">
    Copyright &copy; 2022 Denisse AB Image: Vue.js
  </footer>
</template>
